import { Link } from 'react-router-dom';
import { ArrowRight, Workflow, Fingerprint, Search, TrendingUp, Check } from 'lucide-react';
import { Reveal, SectionHeading } from './Reveal';
import { useLang } from '../i18n';

const PILLARS = [
    { num: '01', icon: Workflow, key: 'pillar1', route: '/servicios/digitalizacion' },
    { num: '02', icon: Fingerprint, key: 'pillar2', route: '/servicios/branding' },
    { num: '03', icon: Search, key: 'pillar3', route: '/servicios/seo-sem' },
    { num: '04', icon: TrendingUp, key: 'pillar4', route: '/servicios/growth-partner' },
];

export default function Services() {
    const { t } = useLang();
    return (
        <section id="servicios" className="py-24 lg:py-32 bg-canvas" data-testid="servicios-section">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
                    <SectionHeading eyebrow={t('sv_eyebrow')} title={t('sv_title')} />
                    <Reveal delay={0.1}>
                        <div className="lg:text-right">
                            <p className="max-w-md text-ink/70 leading-relaxed lg:ml-auto">
                                {t('sv_intro')}
                            </p>
                            <Link to="/servicios" className="inline-flex items-center gap-2 mt-4 text-[12px] font-bold uppercase tracking-[0.14em] text-crimson hover:gap-3 transition-all" data-testid="servicios-ver-todos">
                                {t('sv_ver_todos')}
                                <ArrowRight size={14} />
                            </Link>
                        </div>
                    </Reveal>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mt-14">
                    {PILLARS.map((s, i) => (
                        <Reveal key={s.num} delay={i * 0.08} className="h-full">
                            <Link
                                to={s.route}
                                className="group h-full block rounded-[1.4rem] border border-ink/10 bg-white p-8 lg:p-10 transition-all duration-300 hover:-translate-y-1.5 hover:border-crimson/40 hover:shadow-[0_30px_60px_-30px_rgba(155,28,46,0.35)]"
                                data-testid={`servicio-card-${s.num}`}
                            >
                                <div className="flex items-start justify-between">
                                    <div className="w-12 h-12 rounded-xl bg-pastelblue flex items-center justify-center text-ink group-hover:bg-crimson group-hover:text-pastelcream transition-colors">
                                        <s.icon size={22} strokeWidth={1.75} />
                                    </div>
                                    <span className="font-ink text-sm text-ink/30 tracking-widest">{s.num}</span>
                                </div>
                                <h3 className="font-display text-xl lg:text-2xl font-semibold text-ink mt-6">
                                    {t(`${s.key}_t`)}
                                </h3>
                                <p className="mt-3 text-ink/70 leading-relaxed">{t(`${s.key}_d`)}</p>
                                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-x-4 gap-y-2.5">
                                    {[1, 2, 3, 4].map((n) => (
                                        <li key={n} className="flex items-start gap-2 text-sm text-ink/75">
                                            <Check size={15} className="text-crimson mt-0.5 shrink-0" />
                                            {t(`${s.key}_i${n}`)}
                                        </li>
                                    ))}
                                </ul>
                                <div className="mt-7 flex items-center justify-between gap-3 flex-wrap">
                                    <span className="inline-flex rounded-full border border-crimson/25 bg-pastelpink/50 px-4 py-1.5 text-[11px] font-bold uppercase tracking-[0.14em] text-crimson">
                                        {t(`${s.key}_tag`)}
                                    </span>
                                    <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-[0.14em] text-ink/50 group-hover:text-crimson transition-colors">
                                        {t('sv_ver')}
                                        <ArrowRight size={13} className="transition-transform group-hover:translate-x-1" />
                                    </span>
                                </div>
                            </Link>
                        </Reveal>
                    ))}
                </div>
            </div>
        </section>
    );
}
